import { formatHeaderValue } from "@components/readOnlyList/ReadOnlyList";
import { IReadOnlyListItem } from "@components/readOnlyList/ReadOnlyListItem";
import { IPrEmploymentTemplateEntity, PrEmploymentTemplateEntity } from "@odata/GeneratedEntityTypes";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { IFormViewProps } from "../../../views/formView/FormView";
import EmploymentBaseFormView from "./EmploymentBaseFormView";

interface IProps extends IFormViewProps<IPrEmploymentTemplateEntity, null> {
}

class EmploymentTemplateFormView extends EmploymentBaseFormView<IProps> {
    static contextType = AppContext;
    static defaultProps = {
        title: "Employment:Template.FormTitle"
    };

    getHeaderData = (): IReadOnlyListItem[] => {
        const { storage } = this.props;
        const { bindingContext, entity } = storage.data;

        return [
            {
                label: storage.getInfo(bindingContext.navigate(PrEmploymentTemplateEntity.Name)).label,
                value: formatHeaderValue(entity.Name)
            }
        ];
    };

    get readOnlyListTitle(): string {
        return this.props.storage.t("Employment:Template.TitleSingular");
    }
}

export default withPermissionContext(EmploymentTemplateFormView);